import { atom } from "recoil";
import { SalesLeadData } from "../types/SalesLeadInterface";

export const addStateSalesLead = atom({
  key: "addStateSalesLead",
  default: false,
});
export const editStateSalesLead = atom({
  key: "editStateSalesLead",
  default: false,
});
export const rowEditSalesLead = atom<SalesLeadData | undefined>({
  key: "rowEditSalesLead",
  default: undefined,
});

export const selectedRowsStateSalesLead = atom<SalesLeadData[]>({
  key: "selectedRowsStateSalesLead",
  default: [],
});

export const salesLeadFilterText = atom({
  key: "salesLeadFilterText",
  default: "",
});

export const savingSalesLead = atom({
  key: "savingSalesLead",
  default: false,
});
export const salesLeadFetching = atom({
  key: "salesLeadFetching",
  default: true,
});
